import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useMakePrimary from 'hooks/athlete/connected/useMakePrimary';
import { ConnectedAthlete } from 'types';
import notificationHandler from 'utils/notifications';

interface IMakePrimaryModalProps {
  athlete: ConnectedAthlete | null;
  opened: boolean;
  closeHandler: () => void;
}

const MakePrimaryModal = ({ athlete, opened, closeHandler }: IMakePrimaryModalProps): JSX.Element => {
  const { successNotification, errorNotification } = notificationHandler();
  const makePrimaryMutation = useMakePrimary();

  const handleMakePrimary = (): void => {
    makePrimaryMutation.mutate(athlete?.athleteId || '', {
      onSuccess: () => {
        successNotification('Profile turned into primary profile successfully');
        closeHandler();
      },
      onError: (e: any) => {
        errorNotification(`Something went wrong: ${e.response.data.message}`);
      },
    });
  };

  return (
    <Modal
      opened={opened}
      onClose={closeHandler}
      title={<Title order={4}>Promote to Primary?</Title>}
      size='lg'
      trapFocus
      centered
    >
      <Stack>
        <Text>{`Performing this action will allow the selected profile to manage all payment methods and dependent accounts. The current primary profile will be demoted to a linked profile.`}</Text>
        <Group position='right'>
          <Button
            onClick={handleMakePrimary}
            loading={makePrimaryMutation.isLoading}
            data-cy='makePrimaryContinue'
          >
            Continue
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default MakePrimaryModal;
